<template>
<div id="design-box-metal">
    <p class="rv-title">{{ $t('paintingStepThreeHint') }}</p>
    <div class="rv-tabs">
        <b-tabs card>
            <b-tab :active="isSelectedDesignCategory(i.id)" v-for="i in categories" :key="'dyn-tab-' + i.label" :title="getTranslation(i.label)">
                <tab :label="getTranslation(i.label)" :id="i.id" :boxType="myBoxType" :headerHeight="headerHeight()"></tab>
            </b-tab>
        </b-tabs>
    </div>
    <primary-buttons v-on:cancel="onCancel" v-on:confirm="onConfirm" :confirmable="true"></primary-buttons>
</div>
</template>

<script>

import { PaintingByNumbersModule } from '@/store/modules/paintingByNumbers'
import Tab from '@/components/products/malennachzahlen/Tab.vue'
import PrimaryButtons from '@/components/common/PrimaryButtons.vue'

export default {
    name: 'design-box-metal',
    data: function(){
        return {
            oldDesign: PaintingByNumbersModule.boxDesign,
            categories: [],
            myBoxType: 'METAL_BOX'
        }
    },
    methods: {
        onCancel() {
            PaintingByNumbersModule.SetBoxDesign(this.oldDesign)
            this.$emit('cancel')
        },
        onConfirm() {
            this.$emit('confirm')
        },
        goToMenu: function() {
            this.onCancel()
        },
        getTranslation: function(label) {
            let result = ''
            if (label !== undefined) {
                let parts = label.split(".");
                result = parts[parts.length - 1]
            }
            return this.$t(result).toString()
        },
        hasDesigns(id) {
            let flag = false
            for (let k = 0; k < this.availableDesigns.length; k++){
                if (this.availableDesigns[k].length !== 0){
                    let categoryNr = Number(this.availableDesigns[k][0].designCategories)
                    if (this.availableDesigns[k][0].boxType === this.myBoxType && categoryNr === id) {
                        flag = true
                        let hasOnlineBoxes = false
                        for (let l = 0; l < this.availableDesigns[k].length; l++) {
                            if (this.availableDesigns[k][l].online) {
                                hasOnlineBoxes = true
                                break
                            }
                        }
                        if (!hasOnlineBoxes) {
                            return false
                        }
                    }
                }
            }
            return (this.designsNotEmpty.includes(id) && flag)
        },
        sortList(list){
            return list.sort((a, b) => {
                return a.sort - b.sort;
            });
        },
        headerHeight() {
            let lines =  (this.categories.length - this.categories.length % 4) / 4
            if (this.categories.length % 4 > 0 ) {
                lines++
            }
            let height = 29
            for(let i = 0; i < lines - 1; i++){
                height += 33
            }
            return height
        },
        isSelectedDesignCategory(id) {
            return PaintingByNumbersModule.boxDesignCategory === id
        },
        setCategories() {
            let newCategories = []
            for (let i = 0; i < this.availableCategories.length; i++){
                let currentId = this.availableCategories[i].id
                if (this.hasDesigns(currentId)){
                    newCategories.push(this.availableCategories[i])
                }
            }
            this.categories = this.sortList(newCategories)
        }
    },
    components: {
        Tab,
        PrimaryButtons
    },
    mounted: function() {
        this.$nextTick(() => { this.setCategories() })
    },
    computed: {
        designsNotEmpty: function () {
            return PaintingByNumbersModule.designsNotEmpty
        },
        availableCategories: function () {
            return PaintingByNumbersModule.availableCategories
        },
        availableDesigns: function () {
            return PaintingByNumbersModule.availableDesigns
        },
        updatedCategories: function () {
            return PaintingByNumbersModule.updatedCategories
        }
    },
    watch: {
        updatedCategories: function(newUpdatedCategories) {
            this.$nextTick(() => { this.setCategories() })
        }
    }
}
</script>

<style lang="scss">
#design-box-metal{
    .rv-title{
        margin-bottom:10px;

        @media (max-width: $rv-doubleTeaserBreakpoint) {
            margin-bottom:16px;
        }
    }
    .tabs{
        height:353px;

        @media (max-width: $rv-doubleTeaserBreakpoint) {
            height:auto;
            .card-header-tabs{
                margin-left: 15px;
            }
        }

        .card-header{
            border:none;

            @media (max-width: $rv-doubleTeaserBreakpoint) {
                height:auto;
                border-bottom: 1px solid #656565;
            }
        }

        .nav{
            flex-wrap:wrap;

            @media (max-width: $rv-doubleTeaserBreakpoint) {
                flex-wrap:nowrap;
            }
        }
        .tab-content{
            .rv-img-wrapper{
                width:405px;
                flex-wrap:wrap;
                display: flex;
                justify-content: space-between;
                padding:0;
                margin:auto;

                .rv-box-design{
                    position: relative;
                    width:44px;
                    height: 44px;
                    margin-top: 23.5px;
                    margin-left: 23px;
                    margin-right: 23px;
                    margin-bottom: 23.5px;
                    border: 2px solid $rv-white;
                    border-radius: 5%;
                    cursor:pointer;

                    img{
                        width:auto;
                        height:auto;
                        max-height: 40px;
                        max-width: 40px;
                        position: absolute;
                        margin: auto;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        padding: 2px;
                    }

                    &.selected{
                    border: 2px solid $rv-primary;
                    }
                }
                .rv-box-design:nth-of-type(5n+1){
                    margin-left: 0;
                }
                .rv-box-design:nth-of-type(5n){
                    margin-right: 0;
                }
                @media (max-width: $rv-doubleTeaserBreakpoint) {
                    display: flex;
                    flex-wrap: nowrap;
                    overflow-x: auto;
                    overflow-y: hidden;
                    width: auto;
                    height:auto;
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                    margin-bottom: 5px;
                    padding:0;

                    .rv-box-design{
                        margin-top:15px;
                        margin-left: 12.5px;
                        margin-right: 12.5px;
                        margin-bottom: 10px;
                        height: 100%;

                        img{

                        position: unset;
                        }
                    }
                    .rv-box-design:nth-of-type(5n+1),.rv-box-design:nth-of-type(5n){
                        margin-left: 12.5px;
                        margin-right: 12.5px;
                    }
                }
            }
            .rv-img-wrapper::after {
                content: "";
                flex: auto;
            }
        }
    }
}

</style>